import React from 'react';
import { useEmployeeDashboardModals } from '../hooks/useEmployeeDashboardModals';
import { getEmployeeDashboardModals } from '../config/dashboardModalsConfig';
import { DashboardModalsProvider } from 'framework/ui/dashboard';

interface EmployeeDashboardModalsProviderProps {
  children: React.ReactNode;
}

const EmployeeDashboardModalsProvider: React.FC<EmployeeDashboardModalsProviderProps> = ({ children }) => {
  const { modalCallbacks, globalData } = useEmployeeDashboardModals();
  const modalsWithCallbacks = getEmployeeDashboardModals(modalCallbacks);

  return (
    <DashboardModalsProvider modals={modalsWithCallbacks} globalData={globalData}>
      {children}
    </DashboardModalsProvider>
  );
};

export default EmployeeDashboardModalsProvider;
